import map from "ramda/src/map";
import pick from "ramda/src/pick";
import path from "ramda/src/path";
import prop from "ramda/src/prop";
import find from "ramda/src/find";
import propEq from "ramda/src/propEq";
import uniqBy from "ramda/src/uniqBy";
import applySpec from "ramda/src/applySpec";
import compose from "ramda/src/compose";

import { useEffect } from "react";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { Typography } from "../../UI/Typography";
import { Select } from "../../UI/Select";
import { useHistory, useLocation } from "react-router";
import { URL } from "../../constants/navigation";
import { USER_PAGE_PATHNAME_REGEX } from "../../constants/general";
import { useNetworksContext } from "../../contexts/NetworksProvider";

const getOptions = compose(
  map(
    applySpec({
      value: path<string>(["l1Id"]) as any,
      label: path<string>(["l1Name"]) as any,
    })
  ),
  // @ts-ignore
  uniqBy(prop("l1Id")),
  map(pick(["l1Id", "l1Name"]))
);

const getValue = (id: number) => find(propEq("value", id));

export const NetworksSelectInput = () => {
  const { networks, isLoading } = useNetworksContext();
  const {
    setSelectedNetworkId,
    selectedNetworkId,
  } = useSelectedNetworkContext();
  const location = useLocation();
  const history = useHistory();

  // @ts-ignore
  const options = getOptions(networks);

  useEffect(() => {
    if (networks.length === 0) return;
    const stored = Number(localStorage.getItem("selectedNetworkId"));
    if (stored && networks.some((n: any) => n.l1Id === stored)) {
      setSelectedNetworkId(stored);
    }
  }, [networks]);

  const handleSelectChange = (e: any) => {
    localStorage.setItem("selectedNetworkId", e.value.toString());
    setSelectedNetworkId(e.value);

    if (USER_PAGE_PATHNAME_REGEX.test(location.pathname)) {
      history.replace(URL.USERS_SEARCH);
    }
  };

  const isNoNetworks = networks.length === 0 && !isLoading;
  const isOneNetwork = networks.length === 1;

  return (
    <>
      {isLoading && (
        <Typography variant="subtitle1" color="white">
          Loading networks...
        </Typography>
      )}
      {isNoNetworks && (
        <Typography variant="subtitle1" color="white">
          No networks found
        </Typography>
      )}
      {isOneNetwork && (
        <Typography variant="subtitle1" color="white">
          {options[0].label}
        </Typography>
      )}
      {!isLoading && !isNoNetworks && !isOneNetwork && (
        <Select
          options={options}
          value={getValue(selectedNetworkId)(options) as any}
          onChange={handleSelectChange}
        />
      )}
    </>
  );
};
